// extracted by mini-css-extract-plugin
module.exports = {"table":"calendarLink-module--table--3ew2d","day":"calendarLink-module--day--2raFB"};